import axios from 'axios';

const baseURL = (
  process.env.REACT_APP_YT_AGENT_API || ''
).trim();

const apiYtAgent = axios.create({
  baseURL,
  timeout: 15000
});

apiYtAgent.interceptors.request.use(config => {
  if (!baseURL) {
    return Promise.reject(
      new Error('REACT_APP_YT_AGENT_API não está configurada.')
    );
  }

  const token = localStorage.getItem('tolkenINSV');

  if (!token) {
    return Promise.reject(
      new Error('Sua sessão não está disponível. Entre novamente.')
    );
  }

  config.headers.Authorization = token;

  return config;
});

export default apiYtAgent;